import { postSeguro } from "../../../shared/helper/requests";
import { montaRequerimentoTO, tratarMensagemDeErro } from "../helper";
import { setRequerimentoInicial } from "../onboarding/actions";
import { showError } from "../../../shared/helper/messages";
import isEmpty from "lodash/isEmpty";

export const iniciarValidacao = () => ({
    type: "REQUERIMENTO_VALIDAR_SIBE_INICIAR",
});

export const validarDadosCidadao = () => {
    return (dispatch, getState) => {
        const requerimentoTO = getState().requerimentos.onboarding.requerimentoTO;
        dispatch(iniciarValidacao());
        return postSeguro(
            dispatch,
            `SagService/requerente/validar`,
            montaRequerimentoTO(requerimentoTO),
            (dados) => receberDadosValidacao(dados, dispatch),
            receberErroValidacao
        );
    };

};

const receberDadosValidacao = (requerimentoTO, dispatch) => {
    dispatch(setRequerimentoAposValidarRequerente(requerimentoTO));
    return {
        type: "REQUERIMENTO_VALIDAR_SIBE_RECEBIDO",
        payload: requerimentoTO
    }
};

/* na validacao do requerente os dados adicionais estão sem valor */
export const setRequerimentoAposValidarRequerente = (requerimentoTO) => {
    return (dispatch, getState) => {
        const requerimentoTOLocal = getState().requerimentos.onboarding.requerimentoTO;
        const { contato, etapas, dadosAdicionais, anexos } = requerimentoTOLocal;
        // atualizando com as informacoes existentes no estado/localstorage
        requerimentoTO.contato = contato;
        requerimentoTO.etapas = etapas;
        requerimentoTO.anexos = !isEmpty(anexos) ? anexos : requerimentoTO.anexos;
        /** 
         * atualiza campos adicionais com as informacoes existentes no estado/localstorage somente
         * se mesmo serviço selecionado anteriormente, para caso de pedido inicial x pedido prorrogação.
         */
        if (!isEmpty(dadosAdicionais) && Array.isArray(requerimentoTO?.dadosAdicionais)
            && requerimentoTO?.dadosAdicionais.length === dadosAdicionais?.length) {
            requerimentoTO.dadosAdicionais = dadosAdicionais
        }
        return dispatch(setRequerimentoInicial(requerimentoTO));
    };
}

export const receberErroValidacao = (error) => ({
    type: "REQUERIMENTO_VALIDAR_SIBE_ERROR",
    payload: tratarMensagemDeErro(error),
});

export const closeMessage = () => ({
    type: "REQUERIMENTO_INICIAR_CLOSE_MESSAGE",
});

export const exibirAlertaValidacao = (alerta) => ({
    type: "REQUERIMENTO_DADOS_PEDIDO_ALERTA_VALIDACAO_ERROR",
    payload: alerta,
});

export const setAlert = alert => {
    showError(alert.message);
    return ({
        type: 'REQUERIMENTO_CONCLUIR_SET_ALERT',
        payload: alert
    })
};
